import { makeEnum } from 'utils/other'

export const rolesEnum = makeEnum(['Author', 'Admin'])

export const entitiesEnum = makeEnum(['Post', 'User'])
